import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { getRestEndpoint } from 'src/app/helpers/api-url';
import { Animations } from 'src/app/shared/animations/animations';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './third-party-page.component.html',
  animations: [Animations.leftRightSlider],
  styleUrls: ['./third-party-page.component.scss'],
})
export class ThirdPartyPageComponent implements OnInit {
  constructor(
    private title: Title,
    private authService: AuthService,
  ) {
    this.title.setTitle('Secure Connect');
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  ngOnInit() {
    this.deleteCookie('SC');
    this.authService.silentLogout().catch((error: unknown) => {
      console.error(error);
    });
    this.checkToken();
  }

  checkToken() {
    async function getCookieRedirect() {
      const searchParams = new URLSearchParams(window.location.search);
      const token = searchParams.get('token');
      const redirectUrl = searchParams.get('redirectUrl');

      if (!token) {
        console.log('MISSING TOKEN');
        return;
      }

      const response = await fetch(
        `${getRestEndpoint()}/login?token=${token}`,
        {
          credentials: 'include',
        },
      );
      const isValidToken = await response.json();
      if (isValidToken === true) {
        setTimeout(() => {
          window.location.href = redirectUrl ?? '/dashboard/home';
        }, 1000);
      }
    }

    getCookieRedirect().catch((error: unknown) => {
      console.error(error);
    });
  }
}
